var _path, _circle, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 33H6C4.3 33 3 31.7 3 30V12C3 10.3 4.3 9 6 9h6c0.2 0 0.5-0.2 0.6-0.3l1.1-2.2c0.4-0.8 1.4-1.4 2.3-1.4h8c0.9 0 1.9 0.6 2.3 1.4l1.1 2.2c0.1 0.2 0.4 0.3 0.6 0.3h6c1.7 0 3 1.3 3 3v18c0 1.7-1.3 3-3 3zM6 11c-0.6 0-1 0.4-1 1v18c0 0.6 0.4 1 1 1h28c0.6 0 1-0.4 1-1V12c0-0.6-0.4-1-1-1h-6c-0.9 0-1.9-0.6-2.3-1.4l-1.1-2.2c-0.1-0.2-0.4-0.4-0.6-0.4h-8c-0.2 0-0.5 0.2-0.6 0.3l-1.1 2.2C13.9 10.4 12.9 11 12 11Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 1,
    cy: 13,
    cx: 30
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7 7h4v1H7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m20 16v-1c-2.8 0-5 2.2-5 5h1c0-2.2 1.8-4 4-4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraEmpty);
export default __webpack_public_path__ + "static/media/camera-empty.55a02eb366d81657adcd0fc3f0777ac6.svg";
export { ForwardRef as ReactComponent };